// ─────────────────────────────────────────────────────────────────────────────
// REVIEW — the report card (plan 5.4). Sub-tabs: Today · This Week · This
// Month. This Week and This Month are not drawn yet: they keep the design's
// "Designed next" card (U12). Logic: Buckly.dc.html:1264-1273; markup: :404-448.
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import { designPlaceholder, sx, TabProps } from './primitives';
import { REV_DESIGNED_NEXT, REV_MONTH_TITLE, REV_WEEK_TITLE } from './placeholders';

export function ReviewTab({ s, set }: TabProps) {
  const revSub = s.revSub;
  const v = {
    isRevToday: revSub === 'today', isRevWeek: revSub === 'week', isRevMonth: revSub === 'month',
    revTodayActive: revSub === 'today', revTodayIdle: revSub !== 'today',
    revWeekActive: revSub === 'week', revWeekIdle: revSub !== 'week',
    revMonthActive: revSub === 'month', revMonthIdle: revSub !== 'month',
    onRevToday: () => set({ revSub: 'today' }),
    onRevWeek: () => set({ revSub: 'week' }),
    onRevMonth: () => set({ revSub: 'month' }),
    phRevWeek: designPlaceholder(REV_WEEK_TITLE, REV_DESIGNED_NEXT),
    phRevMonth: designPlaceholder(REV_MONTH_TITLE, REV_DESIGNED_NEXT),
  };

  return (
    // ⟨design Buckly.dc.html:404-448 — generated by dc2tsx.py; regenerate, never hand-edit⟩
    <div style={sx("padding-top:24px;")}>
      {/* SUB-TAB BAR */}
      <div style={sx("display:flex; align-items:center; gap:10px; margin-bottom:20px; flex-wrap:wrap;")}>
        {v.revTodayActive && (
          <button onClick={v.onRevToday} style={sx("padding:9px 18px; border-radius:10px; font-family:inherit; font-size:14px; cursor:pointer; background:rgba(60,150,230,0.16); border:1px solid rgba(60,150,230,0.42); color:#6fc0f2; font-weight:600;")}>Today</button>
        )}
        {v.revTodayIdle && (
          <button onClick={v.onRevToday} style={sx("padding:9px 18px; border-radius:10px; font-family:inherit; font-size:14px; cursor:pointer; background:rgba(255,255,255,0.02); border:1px solid rgba(255,255,255,0.08); color:rgba(210,220,222,0.6);")}>Today</button>
        )}
        {v.revWeekActive && (
          <button onClick={v.onRevWeek} style={sx("padding:9px 18px; border-radius:10px; font-family:inherit; font-size:14px; cursor:pointer; background:rgba(60,150,230,0.16); border:1px solid rgba(60,150,230,0.42); color:#6fc0f2; font-weight:600;")}>This week</button>
        )}
        {v.revWeekIdle && (
          <button onClick={v.onRevWeek} style={sx("padding:9px 18px; border-radius:10px; font-family:inherit; font-size:14px; cursor:pointer; background:rgba(255,255,255,0.02); border:1px solid rgba(255,255,255,0.08); color:rgba(210,220,222,0.6);")}>This week</button>
        )}
        {v.revMonthActive && (
          <button onClick={v.onRevMonth} style={sx("padding:9px 18px; border-radius:10px; font-family:inherit; font-size:14px; cursor:pointer; background:rgba(60,150,230,0.16); border:1px solid rgba(60,150,230,0.42); color:#6fc0f2; font-weight:600;")}>This month</button>
        )}
        {v.revMonthIdle && (
          <button onClick={v.onRevMonth} style={sx("padding:9px 18px; border-radius:10px; font-family:inherit; font-size:14px; cursor:pointer; background:rgba(255,255,255,0.02); border:1px solid rgba(255,255,255,0.08); color:rgba(210,220,222,0.6);")}>This month</button>
        )}
      </div>
      {v.isRevToday && (
        <div>
          <p style={sx("margin:0 0 22px; font-size:14.5px; line-height:1.6; color:rgba(210,220,222,0.62); max-width:900px;")}>The post-session report card the desk already values — written every session, compounded into your memory.</p>
          <div style={sx("display:grid; grid-template-columns:repeat(3, 1fr); gap:20px; align-items:start;")}>
            <div style={sx("padding:24px; border-radius:14px; background:linear-gradient(180deg, rgba(10,16,28,0.7) 0%, rgba(6,9,18,0.8) 100%); border:1px solid rgba(60,150,230,0.2); box-shadow:inset 0 1px 0 rgba(255,255,255,0.04);")}>
              <div style={sx("display:flex; align-items:center; gap:13px; margin-bottom:18px;")}>
                <div style={sx("flex:none; width:40px; height:40px; border-radius:10px; border:1px solid rgba(95,184,240,0.4); display:flex; align-items:center; justify-content:center;")}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5fb8f0" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 13 L10 18 L19 6" />
                  </svg>
                </div>
                <span style={sx("font-size:19px; font-weight:600; color:#f3f7f8;")}>Done well</span>
              </div>
              <div style={sx("display:flex; align-items:center; gap:14px; padding:14px 16px; border-radius:10px; background:rgba(255,255,255,0.02); border:1px solid rgba(255,255,255,0.06); margin-bottom:10px;")}>
                <span style={sx("width:8px; height:8px; border-radius:50%; background:#5fd38a; box-shadow:0 0 7px rgba(95,211,138,0.6);")} />
                <span style={sx("font-size:14px; color:rgba(232,238,240,0.86);")}>Sat out the open as planned</span>
              </div>
              <div style={sx("display:flex; align-items:center; gap:14px; padding:14px 16px; border-radius:10px; background:rgba(255,255,255,0.02); border:1px solid rgba(255,255,255,0.06);")}>
                <span style={sx("width:8px; height:8px; border-radius:50%; background:#5fd38a; box-shadow:0 0 7px rgba(95,211,138,0.6);")} />
                <span style={sx("font-size:14px; color:rgba(232,238,240,0.86);")}>First two trades base size</span>
              </div>
            </div>
            <div style={sx("padding:24px; border-radius:14px; background:linear-gradient(180deg, rgba(10,16,28,0.7) 0%, rgba(6,9,18,0.8) 100%); border:1px solid rgba(60,150,230,0.2); box-shadow:inset 0 1px 0 rgba(255,255,255,0.04);")}>
              <div style={sx("display:flex; align-items:center; gap:13px; margin-bottom:18px;")}>
                <div style={sx("flex:none; width:40px; height:40px; border-radius:10px; border:1px solid rgba(95,184,240,0.4); display:flex; align-items:center; justify-content:center;")}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5fb8f0" strokeWidth="1.8" strokeLinejoin="round" strokeLinecap="round">
                    <path d="M12 3 L22 20 H2 Z" />
                    <path d="M12 10 v4" />
                    <circle cx="12" cy="17" r="0.5" fill="#5fb8f0" />
                  </svg>
                </div>
                <span style={sx("font-size:19px; font-weight:600; color:#f3f7f8;")}>Slipped</span>
              </div>
              <div style={sx("display:flex; align-items:center; gap:14px; padding:14px 16px; border-radius:10px; background:rgba(255,255,255,0.02); border:1px solid rgba(255,255,255,0.06); margin-bottom:10px;")}>
                <span style={sx("width:8px; height:8px; border-radius:50%; background:#eb6a5f; box-shadow:0 0 7px rgba(235,106,95,0.6);")} />
                <span style={sx("font-size:14px; color:rgba(232,238,240,0.86);")}>3rd fade sized up after the loss</span>
              </div>
              <div style={sx("display:flex; align-items:center; gap:14px; padding:14px 16px; border-radius:10px; background:rgba(255,255,255,0.02); border:1px solid rgba(255,255,255,0.06);")}>
                <span style={sx("width:8px; height:8px; border-radius:50%; background:#e6982f; box-shadow:0 0 7px rgba(224,150,52,0.6);")} />
                <span style={sx("font-size:14px; color:rgba(232,238,240,0.86);")}>Cut the runner early</span>
              </div>
            </div>
            <div style={sx("padding:24px; border-radius:14px; background:linear-gradient(180deg, rgba(10,16,28,0.7) 0%, rgba(6,9,18,0.8) 100%); border:1px solid rgba(60,150,230,0.2); box-shadow:inset 0 1px 0 rgba(255,255,255,0.04);")}>
              <div style={sx("display:flex; align-items:center; gap:13px; margin-bottom:18px;")}>
                <div style={sx("flex:none; width:40px; height:40px; border-radius:10px; border:1px solid rgba(95,184,240,0.4); display:flex; align-items:center; justify-content:center;")}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5fb8f0" strokeWidth="1.6">
                    <circle cx="12" cy="12" r="8" />
                    <circle cx="12" cy="12" r="3.4" />
                    <circle cx="12" cy="12" r="0.6" fill="#5fb8f0" />
                  </svg>
                </div>
                <span style={sx("font-size:19px; font-weight:600; color:#f3f7f8;")}>Only paid</span>
              </div>
              <div style={sx("display:flex; align-items:flex-start; gap:14px; padding:14px 16px; border-radius:10px; background:rgba(255,255,255,0.02); border:1px solid rgba(255,255,255,0.06); margin-bottom:14px;")}>
                <span style={sx("margin-top:5px; flex:none; width:8px; height:8px; border-radius:50%; background:#e6982f; box-shadow:0 0 7px rgba(224,150,52,0.6);")} />
                <span style={sx("font-size:14px; line-height:1.45; color:rgba(232,238,240,0.86);")}>{"The oversized fade won — don't log as success"}</span>
              </div>
              <div style={sx("font-size:13px; font-style:italic; color:rgba(120,175,225,0.6); line-height:1.55;")}>A deviation that happened to pay is not a win. Logged as a process miss.</div>
            </div>
          </div>
          <div style={sx("display:flex; align-items:center; gap:9px; margin-top:22px; font-family:'JetBrains Mono',monospace; font-size:11.5px; color:rgba(200,210,212,0.55); flex-wrap:wrap;")}>
            <span style={sx("width:6px; height:6px; border-radius:50%; background:#5fb8f0;")} />
            review composed by PSYCH-SPECIALIST · journal facts from JOURNAL-CURATE · vs desk report-card discipline
            <span style={sx("color:#6fc0f2;")}>HIGHEST</span>
          </div>
        </div>
      )}
      {v.isRevWeek && (
        <>
          {v.phRevWeek}
        </>
      )}
      {' '}
      {v.isRevMonth && (
        <>
          {v.phRevMonth}
        </>
      )}
    </div>
    // ⟨/design⟩
  );
}
